import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useDeleteConsultationNote = () => {
  const queryClient = useQueryClient();
  const handleNetworkError = useHandleNetworkError("Error deleting note");
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (note) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.delete(
        `${tenantVal}/consultationnote/delete`,
        { data: note }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Note deleted");
      queryClient.invalidateQueries({ queryKey: ["consultationNote"] });
      queryClient.invalidateQueries({ queryKey: ["consultationNoteHistory"] });
      queryClient.invalidateQueries({ queryKey: ["activeConsultationNotes"] });
      queryClient.invalidateQueries({ queryKey: ["consultationsList"] });
      queryClient.invalidateQueries({ queryKey: ["activeConsultation"] });
    },
    onError: handleNetworkError,
  });
};
